import React from "react";
import { Avatar, Box, Button, Chip, Typography } from "@mui/material";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

export default function SprintSnapshotCard({
  sprint,
  onOpenSprint,
  onOpenConnections,
  loading = false,
  error = "",
}) {
  const hasSprint = sprint?.status === "Active";

  return (
    <Box
      sx={{
        borderRadius: "20px",
        border: "1px solid #dbe7f3",
        backgroundColor: "#ffffff",
        p: 1.55,
        boxShadow: "0 12px 26px rgba(15, 35, 59, 0.05)",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.95 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "13px",
            display: "grid",
            placeItems: "center",
            backgroundColor: "#eef5f4",
            color: "#2e6256",
          }}
        >
          <GroupsOutlinedIcon sx={{ fontSize: 18 }} />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 900, letterSpacing: 0, color: "#15243b", fontSize: "1.05rem", lineHeight: 1.2 }}>
          {sprint.title}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.8, mt: 0.95, flexWrap: "wrap" }}>
        <Chip
          size="small"
          label={sprint.status}
          sx={{
            fontWeight: 700,
            bgcolor: hasSprint ? "#ecfdf5" : "#f8fafc",
            color: hasSprint ? "#2d8a5f" : "#475569",
          }}
        />
        {sprint.endsIn ? (
          <Typography variant="body2" sx={{ color: "#7f8ea3", fontSize: "0.82rem" }}>
            • {sprint.endsIn}
          </Typography>
        ) : null}
      </Box>
      <Box
        sx={{
          mt: 0.95,
          borderRadius: "16px",
          border: "1px solid #e2e8f0",
          backgroundColor: "#f8fafc",
          p: 0.85,
          display: "flex",
          gap: 1.15,
          alignItems: "center",
        }}
      >
        <Avatar src={sprint.profileImage || ""} sx={{ width: 38, height: 38 }} />
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="body2" sx={{ fontWeight: 800, color: "#102033", fontSize: "0.88rem" }}>
            {loading ? "Preparing your Accountability" : error || sprint.alertTitle}
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.14, color: "#49586c", lineHeight: 1.32, fontSize: "0.82rem" }}>
            {sprint.lastUpdate}
          </Typography>
        </Box>
      </Box>
      <Button
        variant="text"
        onClick={hasSprint ? onOpenSprint : onOpenConnections}
        disabled={loading}
        endIcon={<ChevronRightRoundedIcon />}
        sx={{
          mt: 0.95,
          width: "100%",
          textTransform: "none",
          borderRadius: "14px",
          py: 0.68,
          fontWeight: 800,
          color: "#17345d",
          backgroundColor: "#f3f6fa",
          "&:hover": {
            backgroundColor: "#e9eef5",
          },
        }}
      >
        {hasSprint ? "Open Accountability" : "Open Connections"}
      </Button>
    </Box>
  );
}
